<template>
  <layout-stepper>
    <template #body>
      <div class="d-flex justify-content-center">
        <b-row class="mt-3 col-12 col-lg-8 col-xl-5">
          <b-col class="col-12 text-center mb-3">
            <h1 v-if="!is_adding_brand" class="mb-1">{{ $t('creator.findBrand') }}</h1>
            <h1 v-else class="mb-1">{{ $t('creator.createNrand') }}</h1>
            <p class="mb-2">{{ $t('creator.fromCastingCall') }}</p>

            <div class="d-flex flex-wrap align-items-center justify-content-center" v-if="!is_adding_brand">
             <vue-autosuggest
              :suggestions="[{data: brands}]"
              :limit="10"
              :input-props="input_locations"
              @input="inputBrand"
              v-model="brand"
              :get-suggestion-value="selectBrand"
              :should-render-suggestions="shouldRenderSuggestions"
              @keyup.enter="brand.length > 0 ? save(): ''"
              class="w-100 mb-2"
              > 
                <template slot-scope="{suggestion}">
                  <div class="d-flex justify-content-between cursor-pointer">
                    <div class="d-flex align-items-center">
                      <b-avatar icon="shop" :src="logoImage(suggestion.item)" size="27" class="mr-1"></b-avatar>
                      <span class="my-suggestion-item text-left">{{ suggestion.item.name }}</span>
                    </div>
                    <div>
                      {{suggestion.item.domain}}
                    </div>
                  </div>
                </template>

                <template slot="before-suggestions">
                  <div class="m-1" v-if="brand !== ''">
                    {{$t("search.searchingBy")}}:
                  </div>
                  <hr>
                </template>
                <template slot="after-suggestions">
                  <div class="m-1" v-if="brands.legth === 0">
                    {{$t("search.noResults")}}
                  </div>
                </template>
              </vue-autosuggest>
              <div class="">
                <p class="m-0">{{ $t('creator.cantBrand?') }}</p>
                <b-link @click="is_adding_brand = true">{{ $t('creator.addBrand') }}</b-link>
              </div>
            </div>
            <div v-else class="form-add-brand-step">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div class="container-input-title">
                  <b-form-group :label="$t('creator.nameOrganization')" label-for="input-name" class="form-group-layout">
                    <b-form-input id="input-name" v-model="name" :state="nameState()" @keyup.enter="isPassingValidations() ? saveBrand(): ''"></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback" class="text-left">
                      <span v-if="validName()">{{ $t('creator.200characteres') }}</span>
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>

                <div class="container-input-file">
                  <div class="container-custom-input-file mb-2" v-if="!file_blob">
                    <div class="container-file">
                      <div class="mb-1"><span class="text-blue"><feather-icon icon="ShareIcon" class="mr-03"></feather-icon>Seleccionar</span> o arrastrar Logo aquí</div>
                      <p class="mb-0">Recomendado: imagen cuadrada, menos de 5MB</p>
                    </div>
                    <b-form-file 
                      class="custom-input-logo" 
                      v-model="file" 
                      accept=".jpeg, .jpg, .png" 
                      @input="hasChangeFile"
                    >
                    </b-form-file>
                  </div>
                  <div class="container-blob mb-1" v-else>
                    <div class="container-actions">
                      <div class="container-trash-blob" @click="file_blob = null; file = null; imageDimensionsWarning = false;"> 
                        <feather-icon icon="TrashIcon" class="icon-trash-blob"></feather-icon>
                      </div>
                      
                      <!-- Warning icon with popover -->
                      <div v-if="imageDimensionsWarning" class="container-warning-blob" ref="warningIcon">
                        <feather-icon icon="AlertTriangleIcon" class="icon-warning-blob"></feather-icon>
                      </div>
                    </div>
                    
                    <b-img :src="file_blob" class="img-blob"></b-img>
                    
                    <!-- Popover for dimensions warning -->
                    <b-popover 
                      v-if="imageDimensionsWarning"
                      :target="() => $refs.warningIcon" 
                      triggers="hover"
                      placement="bottom"
                      custom-class="popover-warning"
                    >
                      <div v-if="imageWidth !== imageHeight">
                        <h5 class="title-popover">Dimensiones no ideales</h5>
                        <p class="mb-1">Tu imagen no es cuadrada ({{imageWidth}}x{{imageHeight}}px)</p>
                        <p class="mb-1">Se recomienda una imagen cuadrada</p>
                      </div>
                      <div v-if="fileSizeMB > 5">
                        <h5 class="title-popover">Tamaño no ideal</h5>
                        <p class="mb-1">Tu imagen pesa {{fileSizeMB}}MB</p>
                        <p class="mb-0">Se recomienda menos de 5MB</p>
                      </div>
                    </b-popover>
                  </div>
                </div>
              </div>

              <b-form-group :label="$t('creator.domainOrganization')" label-for="input-domain" class="form-group-layout">
                <b-form-input :state="urlStateExpression(domain) && domain.length < 750" id="input-domain" @keyup.enter="isPassingValidations() ? saveBrand(): ''" v-model="domain" type="url"></b-form-input>
                <b-form-invalid-feedback id="invalid-feedback-url" class="text-left">
                  {{ !urlStateExpression(domain) ? $t('creator.enterUrl') : domain.length > 750 ? $t('creator.750characteres') : 'np'}}
                </b-form-invalid-feedback>
                
              </b-form-group>
              <b-link @click="is_adding_brand = false; clearForm()" class="d-block mb-1 link-back">{{ $t('creator.switchSearch') }}</b-link>
              <b-button :disabled="!isPassingValidations()" variant="blue-button-next-step" class="blue-button-next-step" @click="saveBrand">{{ $t('creator.save') }}</b-button>
            </div>
          </b-col>
          <b-col class="col-12 d-flex justify-content-center" v-if="!is_adding_brand">
            <b-button variant="blue-button-next-step" class="blue-button-next-step" @click="onSave()">{{ $t('creator.save') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </template>
  </layout-stepper>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BAvatar,
  BLink,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BImg,
  BPopover
} from 'bootstrap-vue';
import layoutStepper from '@/views/components/proposals/layoutStepper.vue';
import { VueAutosuggest } from 'vue-autosuggest';
import casting_calls_services from '@/services/casting_calls';
import { isUrl, getAssetUrl, urlStateExpression } from '@/libs/utils/urls'
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');


export default {
  name: 'stepOrganization',
  components: {
    BRow,
    BFormInvalidFeedback,
    BCol,
    BButton,
    BFormFile,
    BFormGroup,
    BFormInput,
    BAvatar,
    BLink,
    layoutStepper,
    BImg,
    VueAutosuggest,
    BPopover,
  },
  data() {
    return {
      isUrl,
      getAssetUrl,
      urlStateExpression,
      brands: [],
      brand: '',
      brand_selected: null,
      is_adding_brand: true,
      input_locations: {
        class: 'form-control',
        placeholder: this.$t('creator.brandUrl')
      },
      file: null,
      file_blob: null,
      imageDimensionsWarning: false,
      imageWidth: null,
      imageHeight: null,
      fileSizeMB: null,
      name: '',
      domain: 'https://',
      steps: null,
    }
  },
  created() {
    this.getBrands('');
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    nameState() {
      return this.name?.length > 0 && this.name?.length < 200
    },
    validName() {
      if (!this.name) return false;
      return this.name?.length > 200
    },
    logoImage(item) {
      if (item.logo_url && item.logo_url.length > 0) {
        return isUrl(item.logo_url) ? item.logo_url : getAssetUrl(item.logo_url)
      } else {
        return isUrl(item.logo) ? item.logo : getAssetUrl(item.logo)
      }
    },
    hasChangeFile() {
      if (this.file) {
        this.imageDimensionsWarning = false;
        
        const maxSize = 5 * 1024 * 1024;
        this.fileSizeMB = (this.file.size / (1024 * 1024)).toFixed(2);
        
        const img = new Image();
        img.onload = () => {
          this.imageWidth = img.width;
          this.imageHeight = img.height;
          
          const isNotSquare = img.width !== img.height;
          const isTooLarge = this.file.size > maxSize;
          
          if (isNotSquare || isTooLarge) {
            this.imageDimensionsWarning = true;
          }
        };
        
        setTimeout(() => {
          this.file_blob = URL.createObjectURL(this.file);
          img.src = this.file_blob;
        }, 200);
      }
    },
    isPassingValidations() {
      const is_passing_all = [];
      is_passing_all.push(urlStateExpression(this.domain) && this.domain.length <= 750);
      is_passing_all.push(!!this.file)
      is_passing_all.push(this.name?.length > 0 && this.name?.length < 200)
      is_passing_all.push(this.fileSizeMB <= 5)
      return is_passing_all.every((item) => item === true);
    },
    shouldRenderSuggestions (size, loading) {
      return size >= 0 && !loading
    },
    selectBrand(value) {
      this.brand = value.item.name;
      this.brand_selected = value.item;
    },
    clearForm() {
      this.file = null;
      this.name = null;
      this.domain = null;
      this.imageDimensionsWarning = false;
      this.imageWidth = null;
      this.imageHeight = null;
      this.fileSizeMB = null;
    },
    inputBrand(value) {
      this.getBrands(value)
    },
    getBrands(query) {
      casting_calls_services.getBrands(query).then((response) => {
        this.brands = response.results;
      });
    },
    saveBrand() {
      const form_data = new FormData();
      form_data.append('name', this.name);
      form_data.append('domain', this.domain);
      form_data.append('logo', this.file);
      casting_calls_services.createBrand(form_data)
        .then((response) => {
          if (response.data && response.data.response && response.data.response.code && response.data.response.code === "brand.domainAlreadyExists") {
            loadToastificationContent().then((component) => {
              this.$toast({
                component: component.default,
                position: 'top-right',
                props: {
                  title: this.$t('creator.error_domain'),
                  text: this.$t('creator.error_domain_again'),
                  icon: "AlertCircleIcon",
                  variant: "danger",
                }
              })
            })
          } else {
            this.setSteps(response)
            if (this.has_slug) {
              this.$router.push({ name: 'preview_casting_call', params: {slug: this.$route.params.slug} });
            } else {
              this.$router.push({ name: 'steps_casting_call', params: {step: 'title-description'} });
            }
            this.clearForm();
          }
        });
    },
    onSave() {
      if (!this.brand) {
        loadToastificationContent().then((module) => {
          this.$toast({
            component: module.default,
            props: {
              title: this.$t('campaigns.titleNoBrand'),
              icon: 'AlertTriangleIcon',
              text: this.$t('campaigns.textNoBrand'),
              variant: 'warning',
            },
          })
        })
        return;
      }

      this.save();
    },
    setSteps(brand) {
      if (this.steps === null) {
        this.steps = {brand}
      } else {
        this.steps.brand = brand;
      }
      localStorage.setItem('steps', JSON.stringify(this.steps));
    },
    save() {
      this.setSteps(this.brand_selected);

      if (this.has_slug) {
        this.$router.push({ name: 'preview_casting_call', params: {slug: this.$route.params.slug} });
      } else {
        this.$router.push({ name: 'steps_casting_call', params: {step: 'title-description'} });
      }
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.custom-input-logo {
  .custom-file-label {
    border: 1px dashed #3483fa !important;
    cursor: pointer;
    color: transparent;
    position: absolute;
    height: 200px !important;
    width: 200px !important;
    top: 0px;
    padding: 0;
    background: transparent !important;
    border-radius: 0.5em;

    &:hover {
      border: 2px solid #3483fa !important;
      cursor: pointer;
    }

    &::after {
      display: none;
    }
  }
}
.popover-warning {
  background: #fff3cd !important;
  .arrow::after {
    border-left-color: #fff3cd !important;
  }
}
</style>
<style>
.form-add-brand-step label {
  text-align: left !important;
}
</style>
<style lang="scss" scoped>
.text-blue {
  color: #3483fa;
}
.mr-03 {
  margin-right: 0.3em;
}
.container-custom-input-file {
  position: relative;
  height: 200px;
  width: 200px;
  margin: 0 auto;
  .container-file {
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: rgba(0,0,0,.45);
    height: 200px;
    font-size: 11px;
    cursor: pointer;
    padding: 0.5em;
    text-align: center;
  }
}
.container-blob {
  height: 200px;
  width: 200px;
  margin: 0 auto;
  background-color: #DEE2E6;
  border-radius: 0.7em;
  position: relative;
  
  .container-actions {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    display: flex;
    gap: 0.5em;
    z-index: 10;
  }
  
  .container-trash-blob {
    cursor: pointer;
    padding: 0.4em;
    border-radius: 10em;
    background-color: rgba(255, 255, 255, 0.8);
    
    &:hover {
      background-color: #bdc0c4da;
    }
    .icon-trash-blob {
      color: black;
      width: 16px;
      height: 16px;
    }
  }
  
  .container-warning-blob {
    cursor: pointer;
    padding: 0.4em;
    border-radius: 10em;
    background-color: #fff3cd;
    
    &:hover {
      background-color: #ffeaa7;
    }
    .icon-warning-blob {
      color: #856404;
      width: 16px;
      height: 16px;
    }
  }
  
  .img-blob {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.container-input-title {
  flex: 1;
  margin-right: 2rem;
  
  .form-group-layout {
    margin-bottom: 0;
  }
}

.container-input-file {
  flex-shrink: 0;
}
</style>